export default "__VITE_ASSET__DaOx6NPP__"